import { MarkerInformation } from "./MarkerInformation";

export default MarkerInformation;
